import { Award, ExternalLink } from 'lucide-react'
import { motion } from 'motion/react'
import { useLocale } from '../context/LocaleContext'
import { SectionHeading } from './SectionHeading'

export function CertificatesSection() {
  const { content } = useLocale()
  const { ui, certificates } = content
  return (
    <section className="learning-section section-shell" id="learning">
      <SectionHeading eyebrow={ui.learningEyebrow} title={ui.learningTitle} intro={ui.learningIntro} />
      <div className="certificate-grid">
        {certificates.map((certificate, index) => (
            <motion.a
              key={certificate.credentialUrl}
              className="certificate-card"
              href={certificate.credentialUrl}
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: Math.min(index * 0.025, 0.2) }}
            >
              <span className="certificate-icon"><Award /></span>
              <span><small>{certificate.issuer}</small><strong>{certificate.title}</strong></span>
              <ExternalLink size={16} />
            </motion.a>
        ))}
      </div>
    </section>
  )
}
